import { APP_NAME } from '@/utils/constants';
import Image from 'next/image';

type Props = {
  width?: number;
};
export const Logo = ({ width = 100 }: Props) => {
  return (
    <Image
      alt={APP_NAME}
      height={50}
      src="/images/logo.svg"
      width={width}
    />
  );
};

export default Logo;
